import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var GatewayTimeoutError = function GatewayTimeoutError(message) {
    _classCallCheck(this, GatewayTimeoutError);

    this.message = message;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/gateway-timeout.js
// module id = ./src/abstractions/errors/gateway-timeout.js
// module chunks = 34